var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "L4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 230,
    cy: 250,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: 0.1,
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    repeatCount: "indefinite",
    restart: "always",
    values: "0;1;0"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 250,
    cy: 250,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: 0.2,
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    repeatCount: "indefinite",
    restart: "always",
    values: "0;1;0"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 270,
    cy: 250,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: 0.3,
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    repeatCount: "indefinite",
    restart: "always",
    values: "0;1;0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.b25a5b1bc861e6420bd2596f1829fbee.svg";
export { ForwardRef as ReactComponent };